const SUPPORT_URL =
	'https://jira.worldline-solutions.com/secure/CreateIssueDetails!' +
	'init.jspa?pid=282237&issuetype=3&summary=Login+Tunz&description=Dear+team%2C+could+you+help+' +
	'me+accessing+my+account+on+https%3A%2F%2Fbackoffice.tunz.com+%3F&customfield_104705=242467&customfield_118145=' +
	'236808&priority=4&customfield_12140=GOPAY-411&customfield_116341=241&labels=Tunz-account';
export default SUPPORT_URL;
